var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlassBeer = function SvgGlassBeer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.5 11.5v7m6-7v7m-3-7v7M17 9h2a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6L17 18m0-10v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8zm-1.035-3a3.5 3.5 0 0 0-6.328-1.514A3.001 3.001 0 0 0 5.17 5H4.5a1.5 1.5 0 1 0 0 3h12a1.5 1.5 0 0 0 0-3z"
  })));
};
export default SvgGlassBeer;